var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCartSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    stroke: "#fff",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.75l.5 3.5M8.5 8.75v3.5M11.5 8.75l-.5 3.5M1.865 9.894c-.296-1.331-.443-1.997-.271-2.52a2 2 0 01.876-1.093C2.943 6 3.625 6 4.99 6h7.02c1.365 0 2.047 0 2.52.281a2 2 0 01.876 1.093c.172.523.024 1.189-.271 2.52l-.578 2.6c-.199.894-.298 1.341-.539 1.675-.212.294-.5.525-.833.669-.378.162-.836.162-1.752.162H5.567c-.916 0-1.374 0-1.752-.162a2 2 0 01-.833-.669c-.24-.334-.34-.78-.539-1.675zM12.5 5.5c0-2.485-1.79-4.5-4-4.5s-4 2.015-4 4.5"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--cart-small-c33c2f9dd3126efa94dd4d6cb49c0364.svg";
export { SvgIconUiCartSmall as Component };